<template>
  <button
    v-ripple
    :is="tag"
    :class="[outlined ? setOutline() : setBgColor(), 'overflow-hidden', 'outline-none', `text-${align}`, active ? 'bcq-btn-active' : null, uppercase ? 'uppercase' : null, bold ? 'font-semibold' : null, baseCss, icon ? null : `py-${sizes[size].spacing}`, plain ? 'bg-btn-plain' : null, loading ? ['bcq-btn-loading', 'pointer-events-none'] : null, icon ? ['bcq-btn-icon', 'rounded-full'] : null, block ? ['block', 'w-full'] : 'inline-block', setTextColor(), icon ? null : 'px-3', fancy && !rounded ? 'rounded-full' : null, rounded && !fancy ? 'rounded' : null, disabled ? ['disabled'] : null, `shadow-${elevation}`]"
    :disabled="disabled"
    :type="type"
    :to="to"
    @click="$emit('click')"
    @mouseover="$emit('mouseover')"
    @mouseout="$emit('mouseout')"
    @mousedown="$emit('mousedown')"
    @focusin="$emit('focusin')"
    @focusout="$emit('focusout')"
    @blur="$emit('blur')"
    @focus="$emit('focus')">
    <div :class="[loading ? 'relative' : null]">
      <template v-if="icon">
        <icon :provider="iconProvider" :size="sizes[size].icon" :name="icon" :color="color" :color-lightness="colorLightness" :class="[loading? 'invisible' : null, `m-${sizes[size].spacing}`]" />
      </template>
      <template v-else>
        <icon :provider="iconProvider" v-if="iconLeft" :size="sizes[size].icon" :name="iconLeft" :color="color" :color-lightness="colorLightness" :class="[loading? 'invisible' : null, $slots.default ? 'mr-2' : null, 'bcq-btn-icon-left']" /><!--
        --><span :style="{width}" :class="[loading? 'invisible' : null, !$slots.default ? ['overflow-hidden', 'w-0', 'invisible'] : null, 'bcq-btn-text', 'inline-block', 'align-middle', `text-${size}`]">
        <template v-if="!$slots.default">&nbsp;</template><slot />
      </span><icon :provider="iconProvider" :size="sizes[size].icon" v-if="iconRight" :name="iconRight" :color="color" :color-lightness="colorLightness" :class="[loading? 'invisible' : null, $slots.default ? 'ml-2' : null, 'bcq-btn-icon-right']" />
      </template>
      <div v-if="loading" :class="['absolute', 'top-0', 'right-0', 'bottom-0', 'left-0']">
        <icon :provider="iconProvider" :size="sizes[size].icon" name="loading" :color="color" :class="['animate-spin']" :color-lightness="colorLightness" />
      </div>
    </div>
  </button>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'Btn',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      sizes: {
        xs: {
          icon: 1,
          spacing: 1
        },
        sm: {
          icon: 1.25,
          spacing: 1
        },
        base: {
          icon: 1.5,
          spacing: 1.5
        },
        lg: {
          icon: 1.75,
          spacing: 2
        },
        xl: {
          icon: 2,
          spacing: 2
        }
      },
      baseCss: this.componentBaseCss('btn', ['transition-all', 'outline-none', 'relative', 'ease-in-out', 'duration-250', 'whitespace-nowrap', 'cursor-pointer', 'align-middle', 'select-none', 'overflow-hidden'])
    }
  },
  props: {
    outlined: {
      type: Boolean
    },
    align: {
      type: String,
      default: 'center'
    },
    uppercase: {
      type: Boolean,
      default: true
    },
    bold: {
      type: Boolean,
      default: true
    },
    fancy: {
      type: Boolean
    },
    type: {
      type: String,
      default: 'button',
      validator: value => {
        return ['button', 'submit', 'reset'].includes(value)
      }
    },
    size: {
      type: String,
      default: 'base',
      validator: value => {
        return ['xs', 'sm', 'base', 'lg', 'xl'].includes(value)
      }
    },
    width: {
      type: String
    },
    tag: {
      type: String,
      default: 'button'
    },
    to: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean
    },
    block: {
      type: Boolean
    },
    plain: {
      type: Boolean
    },
    active: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    iconLeft: {
      type: String
    },
    iconRight: {
      type: String
    },
    bgColor: {
      type: String,
      default: 'gray'
    },
    color: {
      type: String,
      default: 'black'
    },
    icon: {
      type: String
    }
  }
}
</script>
<style>
.bcq-btn
{
  line-height: 1;
}

.bcq-btn:not(.disabled)::before
{
  content: '';
  display: block;
  position: absolute;
  pointer-events: none;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, .1);
  transition: all .5s ease-in-out;
}

.bcq-btn:hover:not(.disabled)::before
{
  background: rgba(255, 255, 255, 0);
}

.bcq-btn:active:not(.disabled)::before,
.bcq-btn.bcq-btn-active:not(.disabled)::before
{
  background: rgba(0, 0, 0, .2);
}

.bcq-btn.bcq-btn-icon
{
  aspect-ratio: 1/1;
}

.bcq-btn.bg-btn-plain
{
  background: none !important;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/btn/btn.vue